import React, { FC } from 'react';
import { Modal } from 'antd';
import { Button } from 'src/screens/OnboardingTrainer/components/Button/Button';
import { ReactComponent as WarningIcon } from 'src/assets/images/onboarding-trainer/solar_danger-triangle-linear.svg';
import { ReactComponent as BackIcon } from 'src/assets/images/onboarding-trainer/dashboard/program-generator-ai/back.svg';

interface ReplaceProgramModalProps {
  isOpen: boolean;
  onKeep: () => void;
  onReplace: () => void;
  isReplacing?: boolean;
}

export const ReplaceProgramModal: FC<ReplaceProgramModalProps> = ({
  isOpen,
  onKeep,
  onReplace,
  isReplacing,
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onKeep}
      footer={null}
      closeIcon={false}
      rootClassName="logout-modal"
      className="replace-program-modal"
      centered
      width={536}
    >
      <div className="replace-program-content">
        <div className="icon-container">
          <WarningIcon />
        </div>
        <h2 className="title">Replace the current program?</h2>
        <p className="description">
          This client already has an active program. Assigning a new one will replace it, and any
          progress in the current program will be lost.
        </p>
        <div className="modal-actions">
          <Button
            variant="outline"
            className="back-btn align-items-center"
            onClick={onKeep}
            svg={<BackIcon />}
            disabled={isReplacing}
          >
            Keep Current Program
          </Button>
          <Button
            variant="primary"
            className="btn-primary-white replace-btn"
            onClick={onReplace}
            isLoading={isReplacing}
            disabled={isReplacing}
          >
            <span style={{ color: '#000', fontWeight: 'bold' }}>Replace Program</span>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
